import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { updateQualification, UPDATE_QUALIFICATION} from "../../actions/student.action"

function* handleUpdateQualification(action) {
  try {
    const { data : resData} = yield call(studentAPI.updateQualification, action.payload);
    //extract the data here     
    yield put(updateQualification.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(updateQualification.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* updateQualificationSaga() {
  yield takeLatest(UPDATE_QUALIFICATION.REQUEST, handleUpdateQualification);
}

export default updateQualificationSaga;
